import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatabasesDisplayGridRowDataFragmentGql } from './DatabasesDisplayGridRowFragmentGql';

export const TableUpstreamDatabasesFilteredByColumnQueryGql: DocumentNode = gql`
query TableUpstreamDatabasesFilteredByColumnQuery(
  $tableId: ID!,
  $columnId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: DatabaseSortOrder!,
  $publishedConnectionsLineageEnabled: Boolean!
) {
  tables(filter: { id: $tableId }) {
    columns(filter: { id: $columnId }) {
      upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatabasesDisplayGridRowDataFragment
        }
      }
      maxDownstreamDatasources: upstreamDatabasesConnection(
        orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection { totalCount }
        }
      }
      maxDownstreamWorkbooks: upstreamDatabasesConnection(
        orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection { totalCount }
        }
      }
    }
  }
}
${DatabasesDisplayGridRowDataFragmentGql}
`;
